module.exports = __webpack_public_path__ + "img/bank-011-nh.7736ff8c.svg";